;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'clsx';

import { BLOCKS } from '@contentful/rich-text-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import RichText from 'components/ui/RichText';
import Text from 'components/ui/Text';

import styles from './TalesBlockIntro.module.scss';

const richTextOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text
                    as="p"
                    className={styles.copy}
                    baseTheme="bodySmall"
                    themes={{
                        medium: 'bodyMedium',
                        large: 'bodyLarge',
                    }}
                >
                    {children}
                </Text>
            );
        },
    },
};

const TalesBlockIntro = ({
    eyebrow,
    headline,
    copy,
    richText,
    anchorCta,
    isActive,
    onAnchorClick,
}) => {
    const rootRef = useRef(null);
    const [isInView, setIsInView] = useState(false);
    const [isAboveFold, setIsAboveFold] = useState(false);

    const intersection = useIntersection(rootRef, {
        root: null,
        rootMargin: '0px',
        threshold: 0.25,
    });

    useEffect(() => {
        if (intersection?.isIntersecting && isActive) {
            setIsInView(true);
        }

        if (!isActive) {
            setIsInView(false);
        }
    }, [intersection, isActive]);

    useEffect(() => {
        const handleResize = () => {
            if (rootRef.current && isActive) {
                const heightAbove = calculateTotalHeightAbove();
                if (heightAbove <= window.innerHeight) {
                    setIsAboveFold(true);
                } else {
                    setIsAboveFold(false);
                }
            }
        };

        const calculateTotalHeightAbove = () => {
            let totalHeight = 0;
            let sibling = rootRef.current.previousElementSibling;

            while (sibling) {
                totalHeight += sibling.offsetHeight;
                sibling = sibling.previousElementSibling;
            }

            return totalHeight;
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isActive]);

    return (
        <section
            ref={rootRef}
            className={cx(styles.root, {
                [styles.isInView]: isInView,
                [styles.isAboveFold]: isAboveFold,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.content}>
                    {eyebrow && (
                        <Text
                            className={styles.eyebrow}
                            baseTheme="labelSmall"
                            themes={{
                                medium: 'labelLarge',
                            }}
                        >
                            {eyebrow}
                        </Text>
                    )}
                    <Text
                        className={styles.headline}
                        baseTheme="displayXSmall"
                        themes={{
                            medium: 'displayLarge',
                            large: 'displayXLarge',
                        }}
                    >
                        <span dangerouslySetInnerHTML={{ __html: headline }} />
                    </Text>
                    <div className={styles.body}>
                        {richText && (
                            <RichText
                                richText={richText}
                                overrides={richTextOverrides}
                            />
                        )}
                        {copy && (
                            <Text
                                className={styles.copy}
                                baseTheme="bodySmall"
                                themes={{
                                    medium: 'bodyMedium',
                                    large: 'bodyLarge',
                                }}
                            >
                                <span
                                    dangerouslySetInnerHTML={{ __html: copy }}
                                />
                            </Text>
                        )}
                        {anchorCta && onAnchorClick && (
                            <ButtonCTA
                                className={styles.anchorCta}
                                style="filled-blue-ocean"
                                text={anchorCta.text}
                                onClick={() => onAnchorClick(anchorCta.id)}
                                gtm-label={`overlay-anchor-cta-${anchorCta.id}`}
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TalesBlockIntro;
